































































import { Component, Vue, Ref } from "vue-property-decorator";
import FormatServices from "@/components/FormatServices/FormatServices";
import IndicatorCard from "@/components/IndicatorCard";
import Funnel from "@/components/Funnel";
import ExpertsVideo from "@/components/ExpertsVideo";
import BiTopExperts from "@/components/TopExperts/BiTopExperts";
import BiTopCards from "@/components/BiTopCards";
import Intersection from "@/components/Intersection";
import BiMap from "@/components/BiMap";
import axios from "axios";
import TopLikedTasks from "@/components/TopLikedTasks";
import { i18n } from "../plugins/i18n";
import BiPieChart from "@/components/BiPieChart";
import { PieData } from "@/components/BiPieChart.vue";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  name: "BiExperts",

  components: {
    IndicatorCard,
    FormatServices,
    Funnel,
    ExpertsVideo,
    BiTopExperts,
    BiTopCards,
    BiMap,
    TopLikedTasks,
    Intersection,
    BiPieChart,
  },
})
export default class BiExperts extends Vue {
  @Ref("topExpertsRef") topExpertsRef!: any;

  topExpertsData = [];
  likedTasks = [{}, {}, {}, {}, {}];
  popularCasesData = [];
  popularEventsData = [];
  funnelData = {};
  expertsGeo = {};
  expertServices = [];
  indicatorsData: any[] = [{}, {}];
  videosViews: any = null;
  expertVideos: null | number = null;
  filledExperts = null;
  trackOnce = false;
  regionalSmeData: PieData[] = [];

  objectToData(object: { [key: string]: number }) {
    return Object.entries(object).map(([key, value]) => ({
      value,
      label: key,
    }));
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name === "BiExpertsByTaskId") {
        vm.$refs.topExpertsRef.$el.scrollIntoView();
      }
    });
  }

  trackAnalytic() {
    if (this.trackOnce === false) {
      this.$gtag.event("BI_expert_map");
      return (this.trackOnce = true);
    }
  }

  mounted() {
    this.$gtag.pageview({page_path: '/bi_experts'});
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/top-business-cases`)
      .then((value) => {
        this.popularCasesData = value.data.values;
      });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/top-events`)
      .then((value) => {
        this.popularEventsData = value.data.values;
      });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/expert-video-views-count`)
      .then((value) => {
        this.videosViews = value.data.total;
      });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/top-experts`)
      .then((value) => {
        this.topExpertsData = value.data.values;
      });
    Promise.all([
      axios.get(`${process.env.VUE_APP_API_URL}analytics/sme-cooperative-rate`),
      // axios.get(`${process.env.VUE_APP_API_URL}analytics/cooperations-count`).then(res => res.data),
      axios
        .get(`${process.env.VUE_APP_API_URL}analytics/approved-experts-count`)
        .then((res: any) => res.data),
      axios.get(`${process.env.VUE_APP_API_URL}analytics/expert-services`),
      axios
        .get(`${process.env.VUE_APP_API_URL}analytics/expert-videos-count`)
        .then((value) => value.data.total),
    ]).then(([cooperationRate, experts, services, expertVideos]) => {
      const cooperationRateDateTotal = `${Math.round(
        cooperationRate.data.total * 100
      )}%`;

      this.indicatorsData = [
        // {
        //   title: "Зареєстрованих представників бізнесу",
        //   count: sme.total,
        //   data: sme.values,
        //   gradient: "dark"
        // },
        {
          title: `${this.$t("experts.indicator_item1")}`,
          count: experts.total,
          data: experts.values,
          gradient: "dark",
        },
        // {
        //   title: "Надіслали бріф експерту",
        //   count: cooperations.total,
        //   data: cooperations.values,
        //   gradient: "dark"
        // },
        {
          title: `${this.$t("experts.indicator_item2")}`,
          count: cooperationRateDateTotal || "92%",
          data: cooperationRate.data.values || [10, 50, 140, 193],
          gradient: "dark",
        },
      ];
      this.videosViews = parseFloat(
        (this.videosViews / experts.total).toFixed(0)
      );

      this.expertVideos = parseFloat((expertVideos / experts.total).toFixed(1));

      this.filledExperts = experts.total;
      this.expertServices = services.data.values.filter(
        (task: any) => task.id !== "8"
      );
    });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/experts-funnel`)
      .then((res: any) => {
        this.funnelData = res.data.values;
      });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/top-selected-tasks`)
      .then((res) => {
        this.likedTasks = res.data.values.slice(0, 20);
      });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/regional-experts-count`)
      .then((res: any) => {
        this.expertsGeo = res.data.values;
      });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/regional-experts-count`)
      .then((res) => {
        this.regionalSmeData = this.objectToData(res.data.values);
        let otherCities = 0;
        let KievCount = 0;
        const OtherCitiesSmes = this.regionalSmeData.map((item) =>
          item.label !== "Kyiv city"
            ? (otherCities += item.value)
            : (KievCount += item.value)
        );
        const updatedRegionalData = [
          { label: "Київ", value: KievCount },
          { label: "Інші міста", value: otherCities },
        ];
        this.regionalSmeData = updatedRegionalData;
      });
  }
}
